// extracted by mini-css-extract-plugin
export default {"mainDiv__style":"NotFoundPage_mainDiv__style__ASTK8","childDiv__style":"NotFoundPage_childDiv__style__Ba7w3","notFoundImg__style":"NotFoundPage_notFoundImg__style__WK+38"};